// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1g1Kl","icon":"SortAdornment_icon__15r6U","up":"SortAdornment_up__2vGKp","down":"SortAdornment_down__3LOLB","active":"SortAdornment_active__1XVxg"};